<template>
  <div :class="seConnected ? '' : 'smallFormContainer'">
    <div>
      <h1 class="title is-1" v-if="$route.params.team_id">{{ $t("edit-team") }}</h1>
      <h1 class="title is-1" v-else>{{ $t("new-team") }}</h1>

      <div class="p-fluid">
        <div class="p-col-8 p-m-auto">
          <div class="p-my-2">
            <label for="lastname">{{ $t("Division.header") }}</label>
            <Dropdown
              v-model="teams[0].division_id"
              optionLabel="name"
              optionValue="id"
              class="p-mt-2"
              :options="divisions"
              :placeholder="$t('Form.shared.placeholder.division')"
            />
          </div>
        </div>

        <div class="container">
          <div class="p-d-flex p-justify-center">
            <div class="p-col-4">
              <label for="firstname">{{ $t("Form.team.name") }}</label>
            </div>
            <div class="p-col-2">
              <label for="x">{{ $t("Team.abbr") }}</label>
            </div>
            <div class="p-col-2">
              <label for="x">{{ $t("Team.code") }}</label>
            </div>
          </div>

          <div v-for="(t, i) in teams" :key="i" class="p-d-flex p-justify-center">
            <div class="p-col-4">
              <InputText
                id="firstname"
                autofocus
                v-model="t.name"
                :placeholder="`e.g. Team${i + 1}A`"
                class="lighter-placeholder"
                type="text"
                @input="teamInputChange"
              />
            </div>
            <div class="p-col-2">
              <InputText
                id="x"
                autofocus
                v-model="t.shortcode"
                :placeholder="`e.g. T${i + 1}A`"
                class="lighter-placeholder"
                type="text"
              />
            </div>
            <div class="p-col-2">
              <InputText id="x" autofocus v-model="t.longcode" type="text" />
            </div>
          </div>
        </div>
      </div>
      <div class="p-text-center p-mt-3">
        <Button @click="saveTeam" class="p-button-lg" :label="$t('Button.save')" :disabled="!isValid" />
      </div>

      <div class="p-text-center p-mt-5" v-if="teams[0] && teams[0].id">
        <v-popover>
          <Button class="p-button p-button-danger p-button-text" :label="$t('Button.delete_team')" />
          <template slot="popover">
            <div class="popover-wrapper">
              <div class="popover-title">{{ $t("confirm-delete-team.title") }}</div>
              <div class="popover-text">
                {{ $t("confirm-delete-team.text") }}
              </div>
              <div class="popover-actions">
                <Button
                  class="p-button p-button-danger p-button-text"
                  :label="$t('Button.delete_team')"
                  @click="deleteTeam"
                />
                <Button v-close-popover class="p-button p-button-text" :label="$t('Button.cancel')" />
              </div>
            </div>
          </template>
        </v-popover>
      </div>
      <div class="mt-3">
        <PapaParse @save="doBulk" item="team"></PapaParse>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  // dddd
  data() {
    return {
      created_team: {},
      deciding: false,
      divisions: [],
      teams: [
        {
          name: "",
          color: "",
          shortcode: "",
          longcode: "",
          division_id: this.getURLParam("division_id"),
          season_id: "",
        },
      ],
    };
  },
  computed: {
    isValid() {
      return !!this.teams[0].name && !!this.teams[0].division_id;
    },
  },
  methods: {
    teamInputChange() {
      const lastTeam = this.teams[this.teams.length - 1];

      if (lastTeam && !lastTeam.id && lastTeam.name) {
        const newTeam = {
          name: "",
          color: "",
          shortcode: "",
          longcode: "",
          division_id: this.getURLParam("division_id") || lastTeam.division_id,
          season_id: "",
        };
        this.teams.push(newTeam);
      }
    },
    reset() {
      (this.team = {
        name: "",
        color: "",
        shortcode: "",
        longcode: "",
        division_id: this.getURLParam("division_id"),
      }),
        (this.created_team = {});
      this.focusInput("firstname");
    },
    doBulk(links) {
      console.log("DoBulk", links);
      api
        .createBulkTeams(this.$store.getters.currentSeason.id, links)
        .then(response => {
          this.makeToast("success", this.$t("Toast.team_created"));
          this.$store.dispatch("getLeagueInformation");
          this.proceed("/");
          console.log(response);
        })
        .catch(error => {
          alert(this.errors);
        });
    },
    updateColor(color) {
      this.team.color = color.hex;
    },
    deleteTeam() {
      api
        .deleteTeam(this.teams[0].id)
        .then(() => {
          this.makeToast("info", this.$t("Toast.deleted-team"));
          this.$store.dispatch("getLeagueInformation");
          this.goRouter(`/divisions/${this.teams[0].division_id}`);
        })
        .catch(error => {
          this.errors = error.response.data.errors;
          alert(this.errors);
        });
    },
    saveTeam() {
      this.teams[0].name = this.removeBadCharacters(this.teams[0].name);
      this.teams[0].season_id = this.$store.getters.currentSeason.id;
      if (this.teams[0].id) {
        api
          .updateTeam(this.teams[0])
          .then(response => {
            this.makeToast("info", this.$t("Toast.updated-team"));
            this.$store.dispatch("getLeagueInformation");
            this.proceed(`/teams/` + response.data.id);
          })
          .catch(error => {
            console.error(error);
            this.errors = error.response.data.errors;
            alert(this.errors);
          });
      } else {
        let teams = this.teams.filter(team => team.name);
        teams = teams.map(team => {
          team.name = this.removeBadCharacters(team.name);
          team.season_id = this.$store.getters.currentSeason.id;
          return team;
        });

        api
          .createTeams(teams)
          .then(() => {
            this.makeToast("success", this.$t("Toast.created-teams"));
            this.$store.dispatch("getLeagueInformation");
            this.proceed(`/divisions/${teams[0].division_id}`);
          })
          .catch(error => {
            console.error(error);
            this.errors = error.response.data.errors;
            alert(this.errors);
          });
      }
    },
  },
  created() {
    if (this.$route.params.team_id) {
      api.getTeam(this.$route.params.team_id, this.$store.getters.currentSeason.id).then(response => {
        this.teams = [response.data];
      });
    }
  },
  mounted() {
    window.analytics.page();
    this.divisions = this.$store.getters.currentSeason.divisions;
    this.teams[0].season_id = this.$store.getters.currentSeason.id;
    if (this.$store.getters.currentSeason.divisions.length === 1) {
      this.teams[0].division_id = this.$store.getters.currentSeason.divisions[0].id;
    }
    this.focusInput("firstname");
  },
};
</script>

<style scoped lang="scss">
form {
  margin-top: 1rem;
}
</style>
